import { Interval } from "@tonaljs/tonal"
import React from 'react';
import { getKeyTransposedByInterval } from '../lib/transposeKey';

const KeyWrapper = ({ children, ...props }) => {
  if (!children) {
    return null;
  }
  
  const { newKey, transposeLevel } = getKeyTransposedByInterval({ key: props.t, transposeInterval: props.i });
  //console.log(`KeyWr: ${undefined}->${newKey}, ${props.i} -> ${transposeLevel}`);
  return (
    children?.map((child, index) => {
      if (React.isValidElement(child)) {
        return React.cloneElement(child, { t: newKey, org_keytonic: newKey, transposeLevel: transposeLevel })//newOrgT })
      }
      else if (typeof child === "string") {
        return child;
      }
      else {
        return null;
      }
    })
  )
}

export default KeyWrapper;